







































































import Vue from 'vue';
import Button from '../common/Button/Button.vue';
import Input from '../common/Input/Input.vue';
export default Vue.extend({
  components: {
    Input,
    Button,
  },
  props: ['dataType'],
  data() {
    return {
      ruleName: [
        '패턴',
        '카테고리',
        '최소, 최대값',
        '최소, 최대 element 갯수',
        'element 유일성',
      ],
      showRules: [false, false, false, false, false],
      value: {
        pattern: '',
        category: '',
        minMax: {
          minimum: undefined,
          maximum: undefined,
        },
        minMaxElementNum: {
          minElementNum: undefined,
          maxElementNum: undefined,
        },
        elementUniqueness: false,
      },
    };
  },
  methods: {
    onClickLabelsetRuleButton(target: HTMLElement) {
      if (!target.dataset.index) {
        return;
      }

      const index = parseInt(target.dataset.index);

      this.showRules = this.showRules.map((showRule, showRuleIdx) => {
        if (showRuleIdx === index) {
          return !showRule;
        } else {
          return showRule;
        }
      });
    },
  },
  computed: {
    showPatternButton(): boolean {
      return this.dataType === 'string';
    },
    showCategoryButton(): boolean {
      return this.dataType === 'string' || this.dataType == 'number';
    },
    showMinMaxButton(): boolean {
      return this.dataType === 'number';
    },
    showMinMaxElementButton(): boolean {
      return this.dataType === 'array';
    },
    showUniquenessButton(): boolean {
      return this.dataType === 'array';
    },
    showButtons(): boolean[] {
      return [
        this.showPatternButton,
        this.showCategoryButton,
        this.showMinMaxButton,
        this.showMinMaxElementButton,
        this.showUniquenessButton,
      ];
    },
  },
});
